import { useMutation } from "@tanstack/react-query";
import { handleGatewayError } from "@src/data/utils/handleGatewayError";
import { getDownloadedFile, viewFileInNewTab } from "@src/helper/file.helper";
import { displayErrorToast } from "@endya-conformite/ui-kit";

export type ViewFilePayload = {
  siren: string;
  millesime: number;
  pathname: string;
  filename: string;
};

export const useViewFileMutation = () => {
  return useMutation({
    mutationFn: async ({
      siren,
      millesime,
      pathname,
      filename,
    }: ViewFilePayload) => {
      const downloadedFile = await getDownloadedFile(
        siren,
        millesime,
        pathname,
        filename,
        true
      );
      if (downloadedFile) {
        viewFileInNewTab(downloadedFile.file, downloadedFile.filename);
      }
    },
    onError: (error) => {
      handleGatewayError({
        onUnhandled: (err) => {
          console.error(err);
          displayErrorToast(
            "Une erreur est survenue lors de l'ouverture du fichier"
          );
        },
      })(error);
    },
  });
};
